export default function WhyChooseUs() {
  const features = [
    {
      number: '01',
      title: 'Experiencia Real',
      description: '20 años perfeccionando la técnica para aliviar tensiones reales.'
    },
    {
      number: '02',
      title: 'Manos Profesionales',
      description: 'El equipo destaca por su profundo conocimiento de la anatomía y un trato amable y atento.'
    },
    {
      number: '03',
      title: 'Instalaciones Impecables',
      description: 'Un gabinete amplio, cálido y extremadamente limpio. El refugio perfecto en C. Gral. Castaños.'
    },
    {
      number: '04',
      title: 'Enfoque Personalizado',
      description: 'No damos masajes genéricos; encontramos lo que tu cuerpo necesita.'
    }
  ];

  return (
    <section className="py-24 bg-[#F5F1E8]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-serif text-5xl font-medium text-[#2C3E2F] mb-4">
            Por qué elegir Masaje de Vida
          </h2>
          <div className="w-20 h-1 bg-[#A8B5A0] mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-[#FAFAF8] rounded-3xl p-10 hover:bg-white hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className="text-[#A8B5A0]/30 font-sans font-bold text-7xl mb-4">
                {feature.number}
              </div>
              <h3 className="font-sans font-bold text-xl text-[#2C3E2F] mb-3 leading-tight">
                {feature.title}
              </h3>
              <p className="text-[#6B7280] leading-relaxed text-sm">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
